import { Alert, Button, Container, Group, Stack, Text, Title } from "@mantine/core";
import { IconAlertTriangle, IconRefresh } from "@tabler/icons-react";

import { ApiError } from "@kansai-ai-hub/api-client";

interface ErrorFallbackProps {
  error: Error;
  onReset?: () => void;
  /** 表示モード — ページ全体 or 部分（カード内）*/
  variant?: "page" | "inline";
}

export function ErrorFallback({ error, onReset, variant = "inline" }: ErrorFallbackProps) {
  const title = getErrorTitle(error);
  const description = error.message;
  const requestId = error instanceof ApiError ? error.requestId : undefined;

  const content = (
    <Alert
      variant="light"
      color="red"
      title={title}
      icon={<IconAlertTriangle size={20} />}
      radius="md"
    >
      <Stack gap="sm">
        <Text size="sm">{description}</Text>
        {requestId && (
          <Text size="xs" c="dimmed">
            Request ID: <code>{requestId}</code>
          </Text>
        )}
        {onReset && (
          <Group>
            <Button
              variant="outline"
              size="xs"
              leftSection={<IconRefresh size={14} />}
              onClick={onReset}
            >
              再試行
            </Button>
          </Group>
        )}
      </Stack>
    </Alert>
  );

  if (variant === "page") {
    return (
      <Container size="sm" py="xl">
        <Stack gap="lg">
          <Title order={2}>エラーが発生しました</Title>
          {content}
        </Stack>
      </Container>
    );
  }
  return content;
}

function getErrorTitle(error: Error): string {
  if (error instanceof ApiError) {
    if (error.isUnauthorized()) return "認証が必要です";
    if (error.isForbidden()) return "権限がありません";
    if (error.isNotFound()) return "リソースが見つかりません";
    if (error.isConflict()) return "競合が発生しました";
    if (error.isValidationError()) return "入力内容に誤りがあります";
    return `エラー (${error.status})`;
  }
  return "予期しないエラー";
}
